module.exports = __webpack_public_path__ + "static/media/participacao-social.4f9f6b8f.png";